import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Elements, StripeProvider } from "react-stripe-elements";
import { getSubscriptionPlan, getUserTokenDetails, postSubscriptionPlan } from "../../modules/subscription/action";
import "../../style";
import Button from "../FormElement/Button";
import Loader from "../Loader";
import Checkout from "./Checkout/Checkout";
import { config } from "../../config/appConfig";




const styles = {
  root: {
    color: "#00bc84",
    "&$checked": {
      color: "#00bc84"
    }
  },
  checked: {}
};

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      uniqueToken: "",
      isVerified: true,
      open: true,
      userName: "",
      success: false,
      url: "",
      buttonDisable: false,
      openCheckout: false,
      subscriptionId: 0
    };
  }

  componentWillMount() {
    this.handleVerification();
    this.props.getSubscriptionPlan();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userTokenDetails && nextProps.userTokenDetails.enabled) {
      this.setState({ uniqueToken: false });
    }

    if (
      nextProps.userTokenDetails &&
      nextProps.userTokenDetails.status === 500
    ) {
      this.setState({ uniqueToken: false });
    }
    if (
      nextProps.subscriptionList &&
      this.props.subscriptionList !== nextProps.subscriptionList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    }

    if (
      nextProps.subscriptionPlan &&
      this.props.subscriptionPlan !== nextProps.subscriptionPlan &&
      nextProps.subscriptionPlan.status === 200
    ) {
      this.setState({
        // {
        //   url:
        //     this.props.subscriptionPlan &&
        //     this.props.subscriptionPlan.links[0].href
        // },
        // () => {
        //   this.setState({
        success: true
        //});
      });
    }

    if (
      nextProps.userEmailFromLogin &&
      this.props.userEmailFromLogin !== nextProps.userEmailFromLogin
    ) {
      this.setState({
        userName: nextProps.userEmailFromLogin.userEmail,
        isVerified: nextProps.userEmailFromLogin.verified
      });
    }

    // if (
    //   nextProps.userTokenDetails &&
    //   this.props.userTokenDetails !== nextProps.userTokenDetails
    // ) {
    //   this.setState({
    //     userName: nextProps.userTokenDetails.username
    //   });
    // }
  }

  handleSubscriptionPlan = planId => {
    //const { username } = this.props.userTokenDetails;
    //console.log(username, planId, "handleSubscriptionPlan");
    //this.props.postSubscriptionPlan(username, planId);
    this.setState({
      buttonDisable: true,
      openCheckout: true,
      subscriptionId: planId
    });
  };

  handleVerification = () => {
    const url = window.location.href;
    if ((window.location.href.indexOf("codeId") > -1) || (window.location.href.indexOf("code") > -1)) {
      let uniqueToken = url.split("?")[1].split("=")[1];
      if (!uniqueToken) {
        return <Redirect to="/login" />;
      }
      else{
      this.setState(
        {
          uniqueToken: uniqueToken
        },
        this.props.getUserTokenDetails(uniqueToken)
      );
    }
  }
    
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false, isVerified: false });
    if ((window.location.href.indexOf("codeId") > -1) && window.location.href.includes('verifyCounterParty')) {
      window.location.href="/counterpartybilling";
    }

  };

  closeChekout = () => {
    this.setState({
      openCheckout: false,
      subscriptionId: 0,
      buttonDisable: false
    });
  };

  handleAutoRenewal = () => {
    const { checked } = this.state;
    this.setState({
      checked: !checked
    });
  };

  render() {
    const {
      user,
      subscriptionList,
      classes,
      userTokenDetails,
      subscriptionPlan
    } = this.props;
    const {
      fetchingComplete,
      success,
      url,
      buttonDisable,
      userName,
      uniqueToken,
      subscriptionId
    } = this.state;

    // if (!user.signupVerified) {
    //     return <Redirect to="/signup" />
    // }
    
      // if (!uniqueToken) {
      //   alert('check',window.location.href.split("?")[1].split("=")[1], '-',uniqueToken)
      //   return <Redirect to="/login" />;
      // }
   
    

    if (this.props.subStarted) {
      return <Loader />;
    }

    if (success) {
      //   return <Redirect to = {{
      //       pathname : url
      //   }} />;
      window.location.href = this.props.subscriptionPlan.data.links[0].href;
    }

    // if (!userName) {
    //   return <Redirect to = {{
    //           pathname : "/login"
    //       }} />;
    // }

    if (this.props.subError) {
      return (
        <div className="ErrorMessage" style={{ textAlign: "center" }}>
          <h4>{this.props.subError}</h4>
        </div>
      );
    }
     if((window.location.href.indexOf("codeId") > -1) && window.location.href.includes('verifyCounterParty')){
      return (
        <div>
          <Dialog
            className="overlay"
            open={this.state.open}
            onClose={this.handleClose}
          >
            <p
              style={{
                color: "green",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FontAwesomeIcon size="2x" icon={faCheckCircle} />
            </p>
            <DialogContent
              style={{
                padding: "1rem 5rem 1rem 5rem",
                textAlign: "center"
              }}
            >
              Your email has been verified.
            </DialogContent>
            <DialogActions
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Button
                label="Done"
                onclick={this.handleClose}
                color="primary"
                name="OK"
              />
            </DialogActions>
          </Dialog>
        </div>
      )
     }
    return (
      <div>
        {this.state.openCheckout && (
          <StripeProvider apiKey={config.paymentkey}>
            <Elements>
              <Checkout
                handleClose={this.closeChekout}
                open={this.state.openCheckout}
                planId={subscriptionId}
                userDetails={userTokenDetails}
                history={this.props.route.history}
              />
            </Elements>
          </StripeProvider>
        )}
        {!success ? (
          <Grid container spacing={8} style={{ width: "100%" }}>
            <div className="subscription">
              {fetchingComplete
                ? Object.keys(subscriptionList).map((value, index) => (
                    <Grid item sm={6} xs={12} key={index}>
                      <div className="subscription-card" key={index}>
                        <div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* <span />
                      <span /> */}
                            <h3 className="CardHeader">
                              {subscriptionList[value].description}
                            </h3>
                            <span className="backGround" />
                          </div>{" "}
                        </div>{" "}
                        <div className="subscription-body">
                          <div>
                            <div className="plan-properties ">
                              <CheckCircleOutline />{" "}
                              <span>
                                {" "}
                                {subscriptionList[value].currency}{" "}
                                {subscriptionList[value].fees}
                                Annual Fee{" "}
                              </span>{" "}
                            </div>{" "}
                          </div>{" "}
                          <div>
                            <div className="plan-properties ">
                              <CheckCircleOutline />{" "}
                              <span>
                                {" "}
                                {subscriptionList[value].noOfContracts === -1
                                  ? "Unlimited"
                                  : subscriptionList[value].noOfContracts}{" "}
                                Contacts{" "}
                              </span>{" "}
                            </div>{" "}
                          </div>{" "}
                          <div>
                            <div className="plan-properties ">
                              <CheckCircleOutline />{" "}
                              <span>
                                {" "}
                                {subscriptionList[value].noOfTickets === -1
                                  ? "1000+"
                                  : subscriptionList[value].noOfTickets}{" "}
                                Ticket Entries{" "}
                              </span>{" "}
                            </div>{" "}
                          </div>{" "}
                          <div>
                            <div className="plan-properties ">
                              <CheckCircleOutline />{" "}
                              <span>
                                {" "}
                                {subscriptionList[value].noOfLogins}
                                Logins{" "}
                              </span>{" "}
                            </div>{" "}
                          </div>{" "}
                          <div>
                            <div className="plan-properties ">
                              <CheckCircleOutline />{" "}
                              <span>
                                {" "}
                                {subscriptionList[value].name === "Basic"
                                  ? "Limited"
                                  : ""}{" "}
                                Print and Export Capabilities{" "}
                              </span>{" "}
                            </div>{" "}
                          </div>{" "}
                          {/* <div>
                      <div className="plan-properties ">
                        <CheckCircleOutline />{" "}
                        <span> {subscriptionList[value].description} </span>{" "}
                      </div>{" "}
                    </div>{" "} */}
                        </div>{" "}
                        <div className="subscription-footer">
                          <button
                            className="subscription-plan"
                            disabled={buttonDisable}
                            onClick={() =>
                              this.handleSubscriptionPlan(
                                subscriptionList[value].id
                              )
                            }
                            //   to={{
                            //     pathname: `/ProceedSubscription/:${
                            //       subscriptionList[value].fees
                            //     }`
                            //   }}
                          >
                            Select Plan
                            {/* {subscriptionList[value].name}{" "} */}
                          </button>{" "}
                        </div>{" "}
                      </div>
                    </Grid>
                  ))
                : ""}{" "}
              {this.state.isVerified && (
                <div>
                  <Dialog
                    className="overlay"
                    open={this.state.open}
                    onClose={this.handleClose}
                  >
                    <p
                      style={{
                        color: "green",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <FontAwesomeIcon size="2x" icon={faCheckCircle} />
                    </p>
                    <DialogContent
                      style={{
                        padding: "1rem 5rem 1rem 5rem",
                        textAlign: "center"
                      }}
                    >
                      Your email has been verified.
                    </DialogContent>
                    <DialogContent
                      style={{
                        padding: "0 5rem 2rem 5rem",
                        textAlign: "center"
                      }}
                    >
                      Please choose a plan to proceed.
                    </DialogContent>
                    <DialogActions
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <Button
                        label="Done"
                        onclick={this.handleClose}
                        color="primary"
                        name="OK"
                      />
                    </DialogActions>
                  </Dialog>
                </div>
              )}
            </div>
          </Grid>
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    subscriptionList: state.subscriptionList.subscriptionListDetails,
    user: state.user,
    userTokenDetails: state.subscriptionList.tokenDetails,
    subscriptionPlan: state.subscriptionList.subscriptionPlanDetail,
    userEmailFromLogin: state.user,
    subStarted: state.subscriptionList.subStarted,
    subError: state.subscriptionList.subError,
    loginError: state.user.loginError
  };
}
export default connect(
  mapStateToProps,
  { getSubscriptionPlan, postSubscriptionPlan, getUserTokenDetails }
)(Subscription);



// WEBPACK FOOTER //
// ./src/components/public/Subscription.js